import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { FieldShell } from "../../ui/field-shell/field-shell";

export const DomainSelectTrigger = styled(FieldShell)`
    && {
        /* The 360px floor TextField needs would stop the reused homepage search from shrinking. */
        min-width: 0;
        cursor: ${({ $isReadOnly }) => ($isReadOnly ? "not-allowed" : "pointer")};
        background-color: ${({ $isReadOnly }) =>
            $isReadOnly ? colorsPalettes.bluegrey[200] : colorsPalettes.carbon[0]};
    }
`;

export const DomainSelectValue = styled(Text)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
